import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Input, Separator, Text} from '../../../ui';
import css from '../styles/ChangePasswordPopupLayout.module.css';

const getValidationSchema = (t) =>
  Yup.object().shape({
    current_password: Yup.string()
      .min(10, t('emailStep.password_too_short'))
      .max(32, t('emailStep.password_too_long'))
      .required(t('emailStep.password_is_required')),
    password: Yup.string()
      .min(10, t('emailStep.password_too_short'))
      .max(32, t('emailStep.password_too_long'))
      .required(t('emailStep.password_is_required')),
    password_confirmation: Yup.string().oneOf(
      [Yup.ref('password'), null],
      t('emailStep.passwords_must_match')
    ),
  });

const ChangePasswordPopupLayout = ({
  onSubmitClick,
  onCancelClick,
  isLoading,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={'profile.change-password'} />
        </Text>
      </div>
      <Formik
        initialValues={{
          current_password: '',
          password: '',
          password_confirmation: '',
        }}
        onSubmit={onSubmitClick}
        validationSchema={getValidationSchema(t)}
      >
        <Form>
          <>
            <div className={css.formContent}>
              {/*@ts-ignore*/}
              <Input
                placeholder={t('profile.old-password')}
                width={Input.WIDTH.WIDTH_FULL}
                name={'current_password'}
              />
              {/*@ts-ignore*/}
              <Input
                placeholder={t('emailStep.password')}
                width={Input.WIDTH.WIDTH_FULL}
                name={'password'}
                type={Input.TYPES.PASSWORD}
              />
              {/*@ts-ignore*/}
              <Input
                placeholder={t('profile.confirm-password')}
                width={Input.WIDTH.WIDTH_FULL}
                name={'password_confirmation'}
                type={Input.TYPES.PASSWORD}
              />
            </div>
            <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
            <div className={css.buttonsBlock}>
              <div className={css.cancelPseudoButton} onClick={onCancelClick}>
                <Text
                  color={Text.COLOR.GREY}
                  fontWeight={Text.FONT_WEIGHT.MEDIUM}
                  fontSize={Text.FONT_SIZE.SIZE_16}
                >
                  <TextLocal id={'create-course.cancel'} />
                </Text>
              </div>
              <Button
                color={Button.COLOR.PRIMARY}
                height={Button.HEIGHT.REGULAR}
                type={Button.TYPES.SUBMIT}
                isLoading={isLoading}
              >
                <TextLocal id={'profile.save'} />
              </Button>
            </div>
          </>
        </Form>
      </Formik>
    </div>
  );
};

ChangePasswordPopupLayout.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ChangePasswordPopupLayout;
